document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.footer-block');

  function initializeAccordions() {
    if (window.innerWidth < 750) {
      // accordions.forEach(accordion => {
      //   const heading = accordion.querySelector('.footer-block__heading');
      //   const detailsContent = accordion.querySelector('.footer-block__details-content');
    
      //   heading.addEventListener('click', () => {
      //       // Close all other accordions
      //       accordions.forEach(otherAccordion => {
      //           if (otherAccordion !== accordion) {
      //               const otherDetailsContent = otherAccordion.querySelector('.footer-block__details-content');
      //               otherDetailsContent.style.height = '0px';
      //           }
      //       });
    
      //       // Toggle the clicked accordion
      //       if (detailsContent.style.height === '0px' || detailsContent.style.height === '') {
      //           detailsContent.style.height = `${detailsContent.scrollHeight}px`;
      //       } else {
      //           detailsContent.style.height = '0px';
      //       }
      //   });
    
      //   detailsContent.style.height = '0px';
      // });
    } else {
      accordions.forEach(accordion => {
        const heading = accordion.querySelector('.footer-block__heading');
        const detailsContent = accordion.querySelector('.footer-block__details-content');

        const newHeading = heading.cloneNode(true);
        heading.parentNode.replaceChild(newHeading, heading);

        detailsContent.style.height = '';
      });
    }
  }

  initializeAccordions();

  window.addEventListener('resize', initializeAccordions);
});
